import { AddressEntity } from '../entities/address-entity';

export default class State {
  current_postal_code = '';

  items: Array<AddressEntity> = [];
}
